export class SectionLinks {
  static buttons = [];
  static sections = [];
  static observer = null;
  static activeSection = null;

  // =============================================================================
  // Lifecycle
  // =============================================================================
  static init() {
    this.setupSectionLinks();
    this.initIntersectionObserver();
  }

  static destroy() {
    this.destroyIntersectionObserver();
    this.buttons = [];
    this.sections = [];
    this.activeSection = null;
  }

  // =============================================================================
  // Methods
  // =============================================================================
  static setupSectionLinks() {
    // Находим все кнопки с data-scroll-to-href
    const buttons = document.querySelectorAll('button[data-scroll-to-href]');

    this.buttons = [];
    this.sections = [];

    buttons.forEach(button => {
      const href = button.getAttribute('data-scroll-to-href');
      if (!href || !href.startsWith('#')) return;

      const sectionId = href.substring(1); // Убираем #
      const section = document.getElementById(sectionId);

      if (section) {
        this.buttons.push({ element: button, sectionId, section });

        // Добавляем секцию в список для наблюдения (избегаем дубликатов)
        if (!this.sections.find(s => s.id === sectionId)) {
          this.sections.push(section);
        }
      }
    });
  }

  static initIntersectionObserver() {
    if (!this.sections.length) return;

    const options = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setActiveSection(entry.target.id);
        }
      });
    }, options);

    // Наблюдаем за всеми секциями
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  static destroyIntersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  static setActiveSection(sectionId) {
    if (this.activeSection === sectionId) return;

    this.activeSection = sectionId;

    // Обновляем классы на всех кнопках
    this.buttons.forEach(({ element, sectionId: btnSectionId }) => {
      if (btnSectionId === sectionId) {
        element.classList.add('is-active');
      } else {
        element.classList.remove('is-active');
      }
    });
  }

  // =============================================================================
  // Public API для обновления при Swup переходах
  // =============================================================================
  static update() {
    this.destroy();
    this.init();
  }
}
